<template>
  <div class="home-page" v-if="!isLoading">
    <div class="home-head">
      <h1 class="home-title">Applications</h1>
      <div class="home-sub">ACCEN — sélectionne un module</div>
    </div>

    <div class="home-groups">
      <div class="home-col" v-for="(col, ci) in groupColumns" :key="'col' + ci">
        <div
          v-for="id in col"
          :key="id"
          class="home-group"
        >
          <div class="home-group-head">
            <v-icon class="home-group-icon" size="20" :style="{ color: groupColor(id) }">
              {{ groupIcon(id) }}
            </v-icon>
            <span class="home-group-title" :style="{ color: groupColor(id) }">{{ itemsGroupFiltered[id] }}</span>
          </div>

          <div class="home-cards">
            <div
              v-for="elem in getFilteredItem.filter((val) => val.group == id)"
              :key="elem.href"
              class="home-card"
              :style="cardStyle(elem.color)"
              @click="goTo(elem.href)"
            >
              <div class="home-card-icon">
                <v-icon size="38">{{ elem.icon }}</v-icon>
              </div>
              <div class="home-card-text">{{ elem.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="home-loading">
    <v-progress-circular size="120" indeterminate color="#455A64">
      Chargement
    </v-progress-circular>
  </div>
</template>

<script>
import engine from "@/core/index";

export default {
  data() {
    return {
      isLoading: true,
      webApplicationToShow: [],
      itemsGroup: {
        1: "Planning(s)",
        2: "Etat des lieux",
        3: "Autre(s)",
        4: "Gestion",
        5: "Compte rendu",
      },
      items: [
        {
          text: "Disponibilité",
          href: "planning-disponibilite",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
          group: 1,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Livraison",
          href: "planning-livraison",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
          group: 1,
          showInMobile: false,
          showInTablette: true,
        },
        {
          text: "Opérateur",
          href: "planning-operateur",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
          group: 1,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Gestion RDV",
          href: "planning-gestion-rdv-velo",
          color: "#66BB6A",
          icon: "mdi-calendar-month",
          show: false,
          group: 1,
          showInMobile: false,
          showInTablette: true,
        },
        {
          text: "Statistiques",
          href: "statistiques",
          color: "#FFF176",
          icon: "mdi-chart-bar",
          show: false,
          group: 5,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Email visualisation",
          href: "email-visualisation",
          color: "#5C6BC0",
          icon: "mdi-email",
          show: false,
          group: 3,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Materiel",
          href: "etat-des-lieux-materiel",
          color: "#8D6E63",
          icon: "mdi-clipboard-file",
          show: false,
          group: 2,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Vélo",
          href: "etat-des-lieux-velo",
          color: "#8D6E63",
          icon: "mdi-clipboard-file",
          show: false,
          group: 2,
          showInMobile: true,
          showInTablette: true,
        },
        {
          text: "Livraison",
          href: "gestion-livraison",
          color: "#BDBDBD",
          icon: "mdi-map",
          show: false,
          group: 4,
          showInMobile: false,
          showInTablette: true,
        },
        {
          text: "Signature en ligne",
          href: "signature-en-ligne",
          color: "#5C6BC0",
          icon: "mdi-draw",
          show: false,
          group: 3,
          showInMobile: true,
          showInTablette: true,
        }, {
          text: "SAV",
          href: "sav-gestion",
          color: "#BDBDBD",
          icon: "mdi-tools",
          show: false,
          group: 4,
          showInMobile: true,
          showInTablette: true,
        }, {
          text: "Contrat",
          href: "contrat-gestion",
          color: "#BDBDBD",
          icon: "mdi-file-document-outline",
          show: false,
          group: 4,
          showInMobile: true,
          showInTablette: true,
        }, {
          text: "Configuration",
          href: "configuration",
          color: "#607D8B",
          icon: "mdi-cog",
          show: false,
          group: 3,
          showInMobile: true,
          showInTablette: true,
        }
      ],
    };
  },
  mounted() {
    let that = this;
    let token = localStorage.getItem("userToken");
    engine.get_user_by_token(token, function (data) {
      console.log("get_user_by_token", data);

      if (data.code == 0) {
        that.webApplicationToShow =
          data.data.data.data[0].fieldData.web_application_to_show.split(",");
        for (let i = 0; i < that.webApplicationToShow.length; i++) {
          // Sécurité : ignore un href renvoyé par le backend mais absent de la liste
          let item = that.items.find(
            (val) => val.href == that.webApplicationToShow[i]
          );
          if (item) item.show = true;
        }
        that.$store.state.webApplicationToShow = that.webApplicationToShow;
        that.isLoading = false;
      } else {
        that.$router.push("/login");
      }
    });
    this.selectedPage = window.location.pathname.replace("/", "");
  },
  computed: {
    isMobile() {
      return this.$vuetify.display.xs;
    },
    isTablette() {
      return this.$vuetify.display.mdAndDown;
    },
    itemsGroupFiltered() {
      let filteredGroupName = {};
      for (let i = 0; i < this.getFilteredItem.length; i++) {
        filteredGroupName[this.getFilteredItem[i].group] =
          this.itemsGroup[this.getFilteredItem[i].group];
      }
      return filteredGroupName;
    },
    // Répartit les groupes en 2 colonnes alignées en haut (remplies de haut
    // en bas). Le 1er groupe de chaque colonne est ainsi aligné avec l'autre.
    groupColumns() {
      let ids = Object.keys(this.itemsGroupFiltered);
      let cols = this.isMobile ? 1 : 2;
      let perCol = Math.ceil(ids.length / cols) || 1;
      let result = [];
      for (let i = 0; i < ids.length; i += perCol) {
        result.push(ids.slice(i, i + perCol));
      }
      return result;
    },
    getFilteredItem() {
      if (this.isMobile == true) {
        return this.items.filter((val) => (val.show == true && val.showInMobile == true));
      }
      else if (this.isTablette == true) {
        return this.items.filter((val) => (val.show == true && val.showInTablette == true));
      } else {
        return this.items.filter((val) => val.show == true);
      }
    },
  },
  methods: {
    goTo(href) {
      this.$router.push(href);
    },
    cardStyle(color) {
      // Couleur pleine, sans dégradé.
      return {
        backgroundColor: color,
      };
    },
    // Première carte d'un groupe = référence couleur / icône du groupe
    groupFirstItem(id) {
      return this.getFilteredItem.find((val) => val.group == id);
    },
    groupIcon(id) {
      let item = this.groupFirstItem(id);
      return item ? item.icon : "mdi-shape";
    },
    // Couleur du groupe = couleur des cartes, assombrie pour rester lisible
    // sur fond blanc (utile surtout pour le gris et le jaune).
    groupColor(id) {
      let item = this.groupFirstItem(id);
      return this.darkenColor(item ? item.color : "#546E7A", 0.55);
    },
    darkenColor(hex, factor) {
      let c = (hex || "").replace("#", "");
      if (c.length !== 6) return hex;
      let r = Math.round(parseInt(c.substr(0, 2), 16) * factor);
      let g = Math.round(parseInt(c.substr(2, 2), 16) * factor);
      let b = Math.round(parseInt(c.substr(4, 2), 16) * factor);
      return "rgb(" + r + ", " + g + ", " + b + ")";
    },
  },
};
</script>

<style scoped>
.home-page {
  min-height: 90vh;
  padding: 18px 14px 40px;
}

.home-head {
  max-width: 1200px;
  margin: 4px auto 18px;
  padding: 0 4px;
}

.home-title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -.02em;
  color: #0e1620;
  margin: 0;
}

.home-sub {
  font-size: 13.5px;
  color: #3f4a57;
  font-weight: 500;
  margin-top: 2px;
}

/* Deux colonnes alignées en haut : chaque colonne empile ses groupes de
   haut en bas (taille naturelle des cartes), et les hauts des colonnes
   sont alignés (Planning à gauche, Gestion à droite, au même niveau). */
.home-groups {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.home-col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 640px) {
  .home-groups {
    flex-direction: column;
  }
}

.home-group {
  background: #ffffff;
  border: 1px solid #b9c3ce;
  border-radius: 18px;
  padding: 16px 16px 18px;
}

.home-group-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.home-group-bar {
  width: 6px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(160deg, #37474F, #1c262b);
}

.home-group-title {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: .02em;
  text-transform: uppercase;
  color: #16202b;
}

/* auto-fit : quand un groupe n'a qu'une ou deux cartes, elles s'étirent
   pour remplir la largeur du groupe (fini le grand blanc à droite). */
.home-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 14px;
}

.home-card {
  cursor: pointer;
  border-radius: 16px;
  padding: 20px 14px 16px;
  min-height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #ffffff;
  border: 1px solid rgba(0, 0, 0, .12);
  transition: filter .14s ease;
}

.home-card:hover {
  filter: brightness(1.06);
}

.home-card-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, .28);
  border: 1px solid rgba(255, 255, 255, .35);
  color: #ffffff;
}

.home-card-text {
  font-size: 15px;
  font-weight: 800;
  text-align: center;
  line-height: 1.2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, .38);
}

.home-loading {
  text-align: center;
  margin-top: 35vh;
}

/* Jaune "Statistiques" : texte foncé pour rester lisible sur fond clair */
.home-card[style*="rgb(255, 241, 118)"],
.home-card[style*="#FFF176"] {
  color: #5d4d00;
}
.home-card[style*="rgb(255, 241, 118)"] .home-card-icon,
.home-card[style*="#FFF176"] .home-card-icon {
  color: #5d4d00;
  background: rgba(0, 0, 0, .08);
}
.home-card[style*="rgb(255, 241, 118)"] .home-card-text,
.home-card[style*="#FFF176"] .home-card-text {
  text-shadow: none;
}
</style>
